export const VERTICAL_RULER = 'verticalRuler';
export const HORIZONTAL_RULER = 'horizontalRuler';
